import axios from '../utils/axios';

const API_URL = `${process.env.REACT_APP_API_URL}/v1/client/`;

const buildRecallQuery = ({
    sortBy,
    sortOrder,
    searchField,
    searchTerm,
    statusFilter,
    dateFrom,
    dateTo,
}) => {
    const parts = [];

    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }

    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }

    if (searchTerm?.trim()) {
        const field = searchField || 'title';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }

    if (statusFilter && statusFilter !== 'ALL') {
        parts.push(`status==${statusFilter}`);
    }

    if (dateFrom) {
        parts.push(`createdAt=ged=${dateFrom}`);
    }

    if (dateTo) {
        parts.push(`createdAt=led=${dateTo}`);
    }

    return parts.join(',');
};

const getRecallRequests = (clinicId, pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildRecallQuery(queryOptions);

    return axios.get(`${API_URL}clinics/${clinicId}/recalls`, {
        params: {
            pageNo,
            pageSize,
            ...(q ? { q } : {}),
        },
    });
};

const getRecallRequestById = (clinicId, reqId) =>
    axios.get(`${API_URL}clinics/${clinicId}/recalls/${reqId}`);

const createRecallRequest = (clinicId, data) =>
    axios.post(`${API_URL}clinics/${clinicId}/recalls`, {
        title: data.title,
        notes: data.notes,
    });

const uploadRecallFiles = (clinicId, recallId, file) => {
    const formData = new FormData();
    formData.append('file', file);

    return axios.post(`${API_URL}clinics/${clinicId}/recalls/${recallId}/upload-files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
};

const downloadInitialRecallReport = (clinicId, reqId) =>
    axios.get(`${API_URL}clinics/${clinicId}/recalls/${reqId}/initial-report`, {
        responseType: 'blob',
    });

const buildRecallPoolQuery = ({
    sortBy,
    sortOrder,
    searchField,
    searchTerm,
    statusFilter,
    mediumType,
}) => {
    const parts = [];

    if (sortBy) {
        parts.push(`sortBy==${sortBy}`);
    }

    if (sortOrder) {
        parts.push(`sortOrder==${sortOrder}`);
    }

    if (searchTerm?.trim()) {
        const field = searchField || 'lastName';
        parts.push(`${field}==*${searchTerm.trim()}*`);
    }

    if (statusFilter && statusFilter !== 'ALL') {
        parts.push(`status==${statusFilter}`);
    }

    if (mediumType && mediumType !== 'ALL') {
        parts.push(`mediumType==${mediumType}`);
    }

    return parts.join(',');
};

const getRecallPools = (clinicId, pageNo = 0, pageSize = 20, queryOptions = {}) => {
    const q = buildRecallPoolQuery(queryOptions);

    return axios.get(`${API_URL}clinics/${clinicId}/recalls/pools`, {
        params: {
            pageNo,
            pageSize,
            ...(q ? { q } : {}),
        },
    });
};

const getRecallPoolById = (clinicId, poolId) =>
    axios.get(`${API_URL}clinics/${clinicId}/recalls/pools/${poolId}`);

const updateRecallPool = (clinicId, poolId, data) =>
    axios.put(`${API_URL}clinics/${clinicId}/recalls/pools/${poolId}`, data);

const recallService = {
    getRecallRequests,
    getRecallRequestById,
    createRecallRequest,
    uploadRecallFiles,
    downloadInitialRecallReport,
    buildRecallQuery,
    getRecallPools,
    getRecallPoolById,
    updateRecallPool,
    buildRecallPoolQuery,
};

export default recallService;
